var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center"
    },
    [
      _c("div", { staticClass: "fixed inset-0 transition-opacity" }, [
        _c("div", {
          staticClass: "absolute inset-0 bg-gray-500 opacity-75",
          on: { click: _vm.close }
        })
      ]),
      _c(
        "div",
        {
          staticClass:
            "relative bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-2xl sm:w-full sm:p-6",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "modal-headline"
          }
        },
        [
          _c("div", { staticClass: "sm:flex sm:items-start" }, [
            _c(
              "div",
              { staticClass: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" },
              [
                _c(
                  "h3",
                  {
                    staticClass: "text-lg leading-6 font-medium text-gray-900",
                    attrs: { id: "modal-headline" }
                  },
                  [_vm._v(" Welcome to Whatsapp Abandoned Cart Recovery ")]
                ),
                _c("div", { staticClass: "mt-2" }),
                _c(
                  "div",
                  {
                    staticClass:
                      "hidden sm:block absolute top-0 right-0 pt-4 pr-4"
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150",
                        attrs: { type: "button", "aria-label": "Close" },
                        on: { click: _vm.close }
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "h-6 w-6",
                            attrs: {
                              fill: "none",
                              viewBox: "0 0 24 24",
                              stroke: "currentColor"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M6 18L18 6M6 6l12 12"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]
            )
          ]),
          _vm._m(0)
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sm:ml-4 mt-4" }, [
      _c("iframe", {
        attrs: {
          width: "560",
          height: "315",
          src: "https://www.youtube.com/embed/udWWME3YCuI",
          frameborder: "0",
          allow:
            "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen: ""
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }